import React, { forwardRef, useEffect, useImperativeHandle, useRef } from "react";
import { Modal as BootstrapModal } from "bootstrap";
import ReactDOM from 'react-dom';
const Modal = forwardRef(
  ({ id = "modalDefault", title = "Modal Title", children , size="xl" }, ref) => {
    const modalRef = useRef(null);
    const modalInstance = useRef(null);

    useEffect(() => {
        // Initialize the Bootstrap modal instance only once
        modalInstance.current = new BootstrapModal(modalRef.current);
    
        return () => {
          // Cleanup modal instance on unmount
          modalInstance.current.dispose();
        };
      }, []);

      useImperativeHandle(ref, () => ({
        showModal: () => {
          if (modalInstance.current) {
           // alert("modal show called");
            modalInstance.current.show();
          }
        },
        hideModal: () => {
          if (modalInstance.current) {
            //alert("modal hide called");
            modalInstance.current.hide();
          }
        },
      }));

    

    return ReactDOM.createPortal (
      <div className="container">

     
      <div
     
        className="modal fade show"
        id={id}
        tabIndex="-1"
        aria-hidden="true"
        ref={modalRef}
      >
        <div className={`modal-dialog modal-${size} `} role="document">
          <div className="modal-content">
            <div className="modal-header bg-primary text-white">
              <h5 style={{marginTop:-20, fontWeight:'bolder'}} className="modal-title text-white">{title}</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">{children}</div>
          </div>
        </div>
      </div>
      </div>
    , document.getElementById('modal-portal-container'))
  }
);

export default Modal;
